<script setup>
import defiCora from "@/assets/images/defi-cora.svg";
</script>
<script>
import LazyImage from "@/components/atoms/lazy-image";
import Card from "@/components/molecules/card";
import Titre from "@/components/atoms/titre";

export default {
  name: "FideliteMerchDefis",
  components: {
    LazyImage,
    Card,
    Titre
  }
};
</script>
<template>
  <Card
    radius="lg"
    border-color="fidelite-eurocora-500"
  >
    <div class="u-flex u-flex-align-center u-flex-column u-radius-lg u-py-md u-px-sm u-bgcolor-fidelite-eurocora-100 u-full-height">
      <div class="u-text-center u-mb-lg">
        <Titre
          tag="p"
          variant="fidelite-eurocora-600"
          size="xlg"
          class="u-mb-sm"
        >
          Les défis
        </Titre>
        <p class="u-font-20 u-font-700">
          Cagnottez des €urocora en réalisant de nouveaux défis tous les mois&nbsp;!
        </p>
      </div>
      <LazyImage
        :src="defiCora"
        alt=""
        width="304"
        height="130"
      />
    </div>
  </Card>
</template>
<style lang="scss" scoped>
</style>
